// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../styles/fonts/SFUIDisplay-Black.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../styles/fonts/SFUIDisplay-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../styles/fonts/SFUIDisplay-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../styles/fonts/SFUIDisplay-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../styles/fonts/SFUIDisplay-Black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../styles/fonts/SFUIDisplay-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../styles/fonts/SFUIDisplay-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../styles/fonts/SFUIDisplay-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../styles/fonts/SFUIDisplay-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../styles/fonts/SFUIDisplay-Bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../styles/fonts/SFUIDisplay-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../styles/fonts/SFUIDisplay-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../styles/fonts/SFUIDisplay-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../styles/fonts/SFUIDisplay-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../styles/fonts/SFUIDisplay-Light.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../styles/fonts/SFUIDisplay-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../styles/fonts/SFUIDisplay-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../styles/fonts/SFUIDisplay-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../styles/fonts/SFUIDisplay-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../styles/fonts/SFUIDisplay-Medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../styles/fonts/SFUIDisplayRegular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../styles/fonts/SFUIDisplayRegular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../styles/fonts/SFUIDisplay-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../styles/fonts/SFUIDisplay-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../styles/fonts/SFUIDisplay-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../../styles/fonts/SFUIDisplay-Semibold.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#svgFontName" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#svgFontName" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "SFUIDisplay-Black";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplayRegular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("svg"); /* Legacy iOS */
}
@font-face {
  font-family: "SFUIDisplay-Semibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}); /* IE9 Compat Modes */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("svg"); /* Legacy iOS */
}
.permission_dashboard__trZBo {
  width: calc(100% - 250px);
  position: relative;
  left: 250px;
  padding: 20px;
}

.permission_cont2__iqnOJ {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 20px;
}

body {
  background-color: #f3f6f9;
}

.permission_bodythemelight__fmQA5 {
  background-color: #f3f6f9;
}

.permission_bodythemedark__XkwvC {
  background-color: #151521;
}

.permission_headerthemelight__ODmWd {
  background-color: #fff;
}

.permission_headerthemedark__2bUg8 {
  background-color: #151521;
}

.permission_menuthemelight__6XcHs {
  background-color: #fff;
}

.permission_menuthemedark__vs1M9 {
  background-color: #151521;
}

.permission_menulinklightSelected__mdnmD span {
  color: #1d1d1d !important;
  border-radius: 10px;
}

.permission_menulinklightSelected__mdnmD a svg {
  color: #1d1d1d !important;
  border-radius: 10px;
}

.permission_menulinkdarkSelected__GZf5Y {
  color: #fff !important;
  border-radius: 10px;
}

.permission_menulinkdark__bvebz {
  color: #60677e !important;
}

.permission_menulinklight__WyuVg:hover {
  color: #1d1d1d !important;
}

.permission_menulinkdark__bvebz:hover {
  color: #fff !important;
}

.permission_headinglight__4qiPL {
  color: #60677e;
}

.permission_headingdark__wak8G {
  color: #60677e;
}

.permission_searchboxlight__JGCey {
  background-color: #fff;
  border: none;
}

.permission_searchboxdark__jT6xn {
  background-color: #1e1e2d;
  color: #60677e;
}

.permission_searchboxdark__jT6xn::placeholder {
  color: #60677e;
}

.permission_tableheadlight__I\\+kRx {
  background-color: #e9eaf0;
}

.permission_tableheaddark__DuUFJ {
  background-color: #1e1e2d;
  color: #60677e;
}

.permission_tablebodylight__NPM54 {
  background-color: #fff;
}
.permission_tablebodylight__NPM54:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.permission_tablebodydark__oMsml {
  background-color: #1e1e2d;
  color: #60677e;
}
.permission_tablebodydark__oMsml:hover {
  background-color: #252530;
  cursor: pointer;
}

.permission_paginationlight__0EWCD {
  color: #60677e !important;
  font-size: 13px !important;
}

.permission_paginationdark__G881y {
  color: #60677e !important;
  font-size: 13px !important;
}

.permission_formthemelight__cJjED {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.permission_formthemedark__CMNcL {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.permission_formthemedark__CMNcL ::placeholder {
  color: #60677e;
}

.permission_viewformlight__JoyPF {
  background-color: #f3f6f9;
}

.permission_viewformdark__rx-Kl {
  background-color: #151521;
}

.permission_permissionboxlight__nZ0Qn {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.permission_permissionboxdark__GhFcv {
  background-color: #151521;
  border: none;
}

.permission_errormsgclr__uWUDR {
  color: red;
  font-size: 14px;
  font-family: "SFUIDisplayRegular";
  margin-top: 5px;
}

.permission_graphclrlight__ywHb- {
  background-color: #fff;
}

.permission_graphclrdark__6LuZv {
  background-color: #1e1e2d;
}

#permission_card1bglight__2QJSX {
  background: linear-gradient(90deg, rgb(181, 219, 177) 13%, rgb(125, 178, 144) 100%);
}

#permission_card1bgdark__ogZMV {
  background: #392f28;
}

#permission_card2bglight__412IJ {
  background: linear-gradient(90deg, rgb(243, 198, 165) 0%, rgb(248, 163, 168) 100%);
}

#permission_card2bgdark__eZxGd {
  background: #1c3238;
}

#permission_card3bglight__SZzuz {
  background: linear-gradient(90deg, rgb(213, 149, 211) 0%, rgb(174, 132, 192) 100%);
}

#permission_card3bgdark__KC6E5 {
  background: #3a2434;
}

#permission_card4bglight__pPoEz {
  background: linear-gradient(90deg, rgb(140, 212, 214) 0%, rgb(150, 202, 247) 100%);
}

#permission_card4bgdark__RILjM {
  background: #2f264f;
}

.permission_actionbtnlight__PztFs {
  color: rgba(70, 71, 91, 0.8705882353);
}

.permission_actionbtndark__5iyfi {
  color: #60677e;
}

.permission_profiledropdownlight__Rs1Bl {
  background-color: #fff;
}

.permission_profiledropdowndark__7jL8q {
  background-color: #151521;
}

@media only screen and (max-width: 1024px) {
  .permission_dashboard__trZBo {
    width: calc(100% - 50px);
    left: 50px;
  }
}
@media only screen and (max-width: 600px) {
  .permission_cont2__iqnOJ {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px !important;
  }
}
#permission_notfoundbg__P8qJv {
  height: 100vh;
}

.permission_centerbox__PW--D {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  color: #1d1d1d;
  align-items: center;
  height: max-content;
}

.permission_imgdiv__z5Pai {
  justify-content: center;
  display: flex;
}

.permission_pagenotimage__VeDrD {
  width: 250px;
  height: 200px;
}

.permission_pagenotfoundhead__SVAzt {
  font-size: 30px;
  font-family: "SFUIDisplay-Bold";
  color: #28305f;
  text-align: center;
  margin-top: 10px;
}

.permission_pagenotfoundpara__\\+Le6\\+ {
  font-size: 18px;
  font-family: "SFUIDisplayRegular";
  color: #28305f;
  text-align: center;
}

.permission_btnsection__WeQYN {
  display: flex;
  justify-content: center;
}

.permission_gohomebtn__waeHK {
  background-color: #28305f;
  color: #fff;
  border: none;
  padding: 6px 20px 6px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-family: "SFUIDisplayRegular";
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/permission/permission.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,4CAAA,EAAA,qBAAA;EACA,4SAAA,EAI8F,eAAA;ACHhG;ADMA;EACE,+BAAA;EACA,4CAAA,EAAA,qBAAA;EACA,8SAAA,EAI6F,eAAA;ACR/F;ADUA;EACE,gCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAI8F,eAAA;ACZhG;ADeA;EACE,iCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAI+F,eAAA;ACjBjG;ADmBA;EACE,iCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAIoF,eAAA;ACrBtF;ADuBA;EACE,mCAAA;EACA,6CAAA,EAAA,qBAAA;EACA,iTAAA,EAIiG,eAAA;ACzBnG;ADkEA;EACE,yBAbe;EAcf,kBAAA;EACA,WAbc;EAcd,aAbiB;ACnDnB;;ADsEA;EACE,wBAhBU;EAiBV,UAhBS;EAiBT,kBAAA;EACA,aAvBiB;AC5CnB;;ADwEA;EACE,yBAvDgB;ACdlB;;ADyEA;EACE,yBA5DgB;ACVlB;;ADwEA;EACE,yBA9De;ACPjB;;ADyEA;EACE,sBAjEY;ACLd;;ADyEA;EACE,yBAvEe;ACCjB;;AD0EA;EACE,sBA1EY;ACGd;;ADyEA;EACE,yBA/Ee;ACSjB;;AD8EA;EAEE,yBAAA;EACA,mBAAA;AC5EF;;AD8EA;EAEE,yBAAA;EACA,mBAAA;AC5EF;;AD+EA;EAEE,sBAAA;EACA,mBAAA;AC7EF;;ADgFA;EACE,yBAAA;AC7EF;;ADgFA;EAEE,yBAAA;AC9EF;;ADgFA;EAEE,sBAAA;AC9EF;;ADkFA;EACE,cAnHe;ACoCjB;;ADkFA;EACE,cAvHe;ACwCjB;;ADmFA;EACE,sBA9HY;EA+HZ,YAAA;AChFF;;ADmFA;EACE,yBA9HkB;EA+HlB,cAlIe;ACkDjB;;ADkFA;EACE,cArIe;ACsDjB;;ADmFA;EACE,yBAhIiB;ACgDnB;;ADkFA;EACE,yBA1IkB;EA2IlB,cA9Ie;AC+DjB;;ADkFA;EACE,sBApJY;ACqEd;ADiFE;EACE,yBAAA;EACA,eAAA;AC/EJ;;ADkFA;EACE,yBAvJkB;EAwJlB,cA3Je;AC4EjB;ADiFE;EACE,yBAAA;EACA,eAAA;AC/EJ;;ADoFA;EACE,yBAAA;EACA,0BAAA;ACjFF;;ADmFA;EACE,yBAAA;EACA,0BAAA;AChFF;;ADoFA;EACE,sBAjLY;EAkLZ,yBAAA;EACA,qDAAA;ACjFF;;ADmFA;EACE,yBAjLkB;EAkLlB,yBAAA;EACA,eAAA;AChFF;ADkFE;EACE,cAzLa;ACyGjB;;ADsFA;EACE,yBArMgB;ACkHlB;;ADqFA;EACE,yBAvMe;ACqHjB;;ADqFA;EACE,yBAAA;EACA,yBAAA;AClFF;;ADoFA;EACE,yBAAA;EACA,YAAA;ACjFF;;ADoFA;EACE,UAAA;EACA,eAAA;EACA,iCApMe;EAqMf,eAAA;ACjFF;;ADqFA;EACE,sBA1NY;ACwId;;ADqFA;EACE,yBAzNkB;ACuIpB;;ADsFA;EACE,mFAAA;ACnFF;;ADsFA;EACE,mBAAA;ACnFF;;ADsFA;EACE,kFAAA;ACnFF;;ADsFA;EACE,mBAAA;ACnFF;;ADsFA;EACE,kFAAA;ACnFF;;ADsFA;EACE,mBAAA;ACnFF;;ADsFA;EACE,kFAAA;ACnFF;;ADsFA;EACE,mBAAA;ACnFF;;ADwFA;EACE,qCAAA;ACrFF;;ADwFA;EACE,cAvQe;ACkLjB;;AD0FA;EACE,sBAAA;ACvFF;;AD0FA;EACE,yBAAA;ACvFF;;AD0FA;EACE;IACE,wBA7PQ;IA8PR,UA7PO;ECsKT;AACF;AD4FA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;EC1FF;AACF;AAxQA;EACI,aAAA;AA0QJ;;AAxQA;EAEI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,cDmDU;EClDV,mBAAA;EACA,mBAAA;AA0QJ;;AAvQA;EACI,uBAAA;EACA,aAAA;AA0QJ;;AAvQA;EACI,YAAA;EACA,aAAA;AA0QJ;;AAxQA;EACI,eAAA;EACA,+BDgDU;EC/CV,cAAA;EACA,kBAAA;EACA,gBAAA;AA2QJ;;AAzQA;EACI,eAAA;EACA,iCD2Ca;EC1Cb,cAAA;EACA,kBAAA;AA4QJ;;AAzQA;EACI,aAAA;EACA,uBAAA;AA4QJ;;AA1QA;EACI,yBAAA;EACA,WDgBU;ECfV,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,iCD2Ba;ACkPjB","sourcesContent":["@font-face {\n  font-family: 'SFUIDisplay-Black';\n  src: url('../fonts/SFUIDisplay-Black.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Black.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Black.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Black.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Black.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Black.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n@font-face {\n  font-family: 'SFUIDisplay-Bold';\n  src: url('../fonts/SFUIDisplay-Bold.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Bold.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Bold.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Bold.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Bold.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Bold.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplay-Light';\n  src: url('../fonts/SFUIDisplay-Light.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Light.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Light.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Light.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Light.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Light.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n@font-face {\n  font-family: 'SFUIDisplay-Medium';\n  src: url('../fonts/SFUIDisplay-Medium.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Medium.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Medium.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Medium.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Medium.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Medium.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplayRegular';\n  src: url('../fonts/SFUIDisplayRegular.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplayRegular.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplayRegular.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Regular.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Regular.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Regular.svg') format('svg'); /* Legacy iOS */\n}\n@font-face {\n  font-family: 'SFUIDisplay-Semibold';\n  src: url('../fonts/SFUIDisplay-Semibold.eot'); /* IE9 Compat Modes */\n  src: url('../fonts/SFUIDisplay-Semibold.eot?#iefix') format('embedded-opentype'),\n    /* IE6-IE8 */ url('../fonts/SFUIDisplay-Semibold.woff2') format('woff2'),\n    /* Super Modern Browsers */ url('../fonts/SFUIDisplay-Semibold.woff') format('woff'),\n    /* Pretty Modern Browsers */ url('../fonts/SFUIDisplay-Semibold.ttf') format('truetype'),\n    /* Safari, Android, iOS */ url('../fonts/SFUIDisplay-Semibold.svg#svgFontName') format('svg'); /* Legacy iOS */\n}\n\n//scss//\n\n//Body Theme Color\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n//Dark Theme Colors\n$primarydark-color: #1e1e2d;\n\n//Button Theme\n$primary-btncolor: #39979d;\n$primary-btncolor-disabled: #b8b8b8;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n$sffont-bold: 'SFUIDisplay-Bold';\n$sffont-medium: 'SFUIDisplay-Medium';\n$sffont-regular: 'SFUIDisplayRegular';\n\n//Max Dashboard scss//\n\n$dashboardwidth: calc(100% - 250px);\n$dashboardposition: absolute;\n$dashboardleft: 250px;\n$dashboardpadding: 20px;\n\n//Min Dashboard scss//\n\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n//Max Dashboard scss//\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: $dashboardpadding;\n  // background-Color: $dashboardbackgroundColor;\n}\n\n//Min Dashboard scss//\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  // background-Color: $dashboardbackgroundColor;\n  // padding-bottom: 8%;\n}\n\nbody {\n  background-color: $lightthemecolor;\n}\n\n//THEME CHANGE\n.bodythemelight {\n  background-color: $lightthemecolor;\n}\n.bodythemedark {\n  background-color: $darkthemecolor;\n}\n\n//Header Navbar Theme\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkthemecolor;\n}\n\n//LEFT MENU THEME CHANGE\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkthemecolor;\n}\n\n//LEFT MENU LINKS THEME CHANGE\n// .menulinklight {\n//   color: $lightthemetext !important;\n// }\n\n.menulinklightSelected span {\n  // background-color: $lightthemecolor;\n  color: $black-color !important;\n  border-radius: 10px;\n}\n.menulinklightSelected a svg {\n  // background-color: $lightthemecolor;\n  color: $black-color !important;\n  border-radius: 10px;\n}\n\n.menulinkdarkSelected {\n  // background-color: $primarydark-color;\n  color: $white-color !important;\n  border-radius: 10px;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  // background-color: $lightthemecolor;\n  color: $black-color !important;\n}\n.menulinkdark:hover {\n  // background-color: $primarydark-color;\n  color: $white-color !important;\n}\n\n//BODY HEADERS\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n//SEARCH BOX THEME COLOR\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n//CUSTOM TABLE THEME COLOR\n.tableheadlight {\n  background-color: $tableheadlightbg;\n}\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n}\n\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n  background-color: $primarydark-color;\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: #252530;\n    cursor: pointer;\n  }\n}\n\n//PAGINATION THEME COLOR\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n//SETTING FORM THEME COLOR\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n//VIEW FORM DETAILS BOX THEME COLOR\n\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n.viewformdark {\n  background-color: $darkthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: none;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  font-family: $sffont-regular;\n  margin-top: 5px;\n}\n\n//Graph theme\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n//Counter theme\n#card1bglight {\n  background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%);\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%);\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%);\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%);\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n//Action button theme\n\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n//profile dropdowntheme\n\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: $dashwidth;\n    left: $dashleft;\n  }\n\n}  \n\n\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: $dashboardpadding !important;\n  }\n}\n","@import \"/src/styles/Variables/Variables.scss\";\n\n#notfoundbg{\n    height: 100vh;\n}\n.centerbox{\n  \n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    color: $black-color;\n    align-items: center;\n    height: max-content;\n}\n\n.imgdiv{\n    justify-content: center;\n    display: flex;\n}\n\n.pagenotimage{\n    width: 250px;\n    height: 200px;\n}\n.pagenotfoundhead{\n    font-size: 30px;\n    font-family: $sffont-bold;\n    color: #28305f;\n    text-align: center;\n    margin-top: 10px;\n}\n.pagenotfoundpara{\n    font-size: 18px;\n    font-family: $sffont-regular;\n    color: #28305f;\n    text-align: center;\n}\n\n.btnsection{\n    display: flex;\n    justify-content: center;\n}\n.gohomebtn{\n    background-color: #28305f;\n    color: $white-color;\n    border: none;\n    padding: 6px 20px 6px 20px;\n    border-radius: 6px;\n    font-size: 14px;\n    font-family: $sffont-regular;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `permission_dashboard__trZBo`,
	"cont2": `permission_cont2__iqnOJ`,
	"bodythemelight": `permission_bodythemelight__fmQA5`,
	"bodythemedark": `permission_bodythemedark__XkwvC`,
	"headerthemelight": `permission_headerthemelight__ODmWd`,
	"headerthemedark": `permission_headerthemedark__2bUg8`,
	"menuthemelight": `permission_menuthemelight__6XcHs`,
	"menuthemedark": `permission_menuthemedark__vs1M9`,
	"menulinklightSelected": `permission_menulinklightSelected__mdnmD`,
	"menulinkdarkSelected": `permission_menulinkdarkSelected__GZf5Y`,
	"menulinkdark": `permission_menulinkdark__bvebz`,
	"menulinklight": `permission_menulinklight__WyuVg`,
	"headinglight": `permission_headinglight__4qiPL`,
	"headingdark": `permission_headingdark__wak8G`,
	"searchboxlight": `permission_searchboxlight__JGCey`,
	"searchboxdark": `permission_searchboxdark__jT6xn`,
	"tableheadlight": `permission_tableheadlight__I+kRx`,
	"tableheaddark": `permission_tableheaddark__DuUFJ`,
	"tablebodylight": `permission_tablebodylight__NPM54`,
	"tablebodydark": `permission_tablebodydark__oMsml`,
	"paginationlight": `permission_paginationlight__0EWCD`,
	"paginationdark": `permission_paginationdark__G881y`,
	"formthemelight": `permission_formthemelight__cJjED`,
	"formthemedark": `permission_formthemedark__CMNcL`,
	"viewformlight": `permission_viewformlight__JoyPF`,
	"viewformdark": `permission_viewformdark__rx-Kl`,
	"permissionboxlight": `permission_permissionboxlight__nZ0Qn`,
	"permissionboxdark": `permission_permissionboxdark__GhFcv`,
	"errormsgclr": `permission_errormsgclr__uWUDR`,
	"graphclrlight": `permission_graphclrlight__ywHb-`,
	"graphclrdark": `permission_graphclrdark__6LuZv`,
	"card1bglight": `permission_card1bglight__2QJSX`,
	"card1bgdark": `permission_card1bgdark__ogZMV`,
	"card2bglight": `permission_card2bglight__412IJ`,
	"card2bgdark": `permission_card2bgdark__eZxGd`,
	"card3bglight": `permission_card3bglight__SZzuz`,
	"card3bgdark": `permission_card3bgdark__KC6E5`,
	"card4bglight": `permission_card4bglight__pPoEz`,
	"card4bgdark": `permission_card4bgdark__RILjM`,
	"actionbtnlight": `permission_actionbtnlight__PztFs`,
	"actionbtndark": `permission_actionbtndark__5iyfi`,
	"profiledropdownlight": `permission_profiledropdownlight__Rs1Bl`,
	"profiledropdowndark": `permission_profiledropdowndark__7jL8q`,
	"notfoundbg": `permission_notfoundbg__P8qJv`,
	"centerbox": `permission_centerbox__PW--D`,
	"imgdiv": `permission_imgdiv__z5Pai`,
	"pagenotimage": `permission_pagenotimage__VeDrD`,
	"pagenotfoundhead": `permission_pagenotfoundhead__SVAzt`,
	"pagenotfoundpara": `permission_pagenotfoundpara__+Le6+`,
	"btnsection": `permission_btnsection__WeQYN`,
	"gohomebtn": `permission_gohomebtn__waeHK`
};
export default ___CSS_LOADER_EXPORT___;
